export default __webpack_public_path__ + "static/media/10.457a4ddf.svg";